<template>
  <div class="login-form">
    <el-row type="flex" justify="center">
      <h1 class="title">蘭陽地區林業文化歷史資料庫</h1>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-input v-model="email" placeholder="請輸入電子郵件"></el-input>
        <!-- <el-autocomplete 
          style="width:100%"
          type="text" 
          v-model="email" 
          placeholder="請輸入電子郵件"
          :fetch-suggestions="fetch_email_suggestions"
        >
        </el-autocomplete> -->
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-input v-model="password" type="password" placeholder="請輸入密碼"></el-input>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :span="6">
        <el-button class="login-btn" @click="login">登入</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
//import { mapActions, mapGetters } from 'vuex'
// import api from '@/api/index.js'


export default {
  data () {
    return {
      email: '',
      password: '',
      typeError: false,
      // suggested_emails: [
      //   { "value": "blueplanet@demo.com" },
      //   { "value": "super-system-admin@demo.com" },
      //   { "value": "system-admin@demo.com" },
      //   { "value": "part-time-data-input@demo.com"},
      //   { "value": "ordinary-user@demo.com"},
      //   { "value": "some-user@demo.com"},
      // ],
}
  },
  methods: {
    async login () {
      console.log('login button clicked')

      await this.action_login({
        email: this.email,
        password: this.password
      })

      if (this.is_login) {
        console.log('is_login: ',this.is_login)
        
        this.backstage_router_push({
          path: `/`,
          query: {}
        })
      }
    },
    alertErrorMessage (text) {
      let message = ''
      if (text === 'EMAIL_FORMAT_INVALID' || text === 'PASSWORD_LENGTH_INVALID') {
        message = 'EMAIL或密碼格式不符 (提醒: 密碼輸錯10次，帳號會被停用)'
      } else if (text === 'ACCOUNT_OR_PASSWORD_INVALID') {
        message = '帳號或密碼錯誤 (提醒: 密碼輸錯10次，帳號會被停用'
      } else if (text === 'ACCOUNT_LOCKED') {
        alert('錯誤次數已達10次，因資訊安全考量，您的帳號已被鎖定，若要解鎖，請洽客服02-8978-7198或contact@blueplanet.com.tw，謝謝')
      } else if (message === 'ACCOUNT_EXPIRED') {
        alert('此帳戶使用期限已過，若想繼續使用，請洽客服專線02-8978-7198，或來信contact@blueplanet.com.tw')
      } else {
        alert(text)
      }
    },
    fetch_email_suggestions (queryString, cb) {
      var emails = this.suggested_emails;
      //var results = queryString ? emails.filter(this.create_filter(queryString)) : emails;
      //cb(results);
      cb(emails)
    },
    create_filter (queryString) {
        return (email) => {
            return (email.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
    },
  }
}
</script>

<style lang="scss" scoped>
  .login-form {
    height: 100vh;
    width: 100vw;
    background-color:#196f3d;  
  }
  .el-row {
    margin-bottom: 40px;
    &:first-child {
      margin-top: 150px;
    }
    &:last-child {
      margin-bottom: 0;
    }
  }
  .title {
    color: white;
    font-size: 4em;
  }
  .login-btn {
    width: 100%;
  }

  /deep/.el-button,
  /deep/.el-button:visited,
  /deep/.el-button:focus,
  /deep/.el-button:active {
    background-color: grey;
    border-color: grey;
    color: white;
  }

  /deep/.el-button:hover {
      color: white;
      border-color: rgba(#196f3d, 1);
      background-color: rgba(#191919, 0.1);
  }

</style>
